import React from 'react';
import Lottie from 'lottie-react';
import { TGraphic, TModal } from '../../utils/types';
import {
	IllustrationSpar,
	IllustrationDoed,
	IllustrationForsikring,
	IllustrationOvergange,
	IllustrationPension,
	IllustrationSamle,
	IllustrationOrdning,
	IllustrationLivshaendelse
} from '../../utils/illustrations';
import {
	IconCivil,
	IconOekonomi,
	IconNy,
	IconBoern,
	IconSygdom,
	IconPension,
	IconKalender,
	IconDoed,
	IconKontakt,
	IconUddannelse,
	IconFejl,
	IconOpdateret,
	IconSaml,
	IconArbejde,
	IconFritid,
	IconJobskifte,
	IconPlay,
	IconStartPension,
	IconTaleSammen,
	IconUdbetaling
} from '../../utils/icons';

interface GraphicsProps {
  data: TGraphic
  handleClick?: (modalData: TModal) => void
  matomoVideoId?: string;
}

const Graphics = ({ data, handleClick, matomoVideoId }: GraphicsProps) => {
	const { Type, Url, Preview, Title } = data;

	const renderIcon = () => {

		switch (Url) {
		case 'icon-servicetjek-civilstatus': // hjerter
			return <IconCivil />;
		case 'icon-servicetjek-oekonomi': // taske + mønter
			return <IconOekonomi />;
		case 'icon-servicetjek-ny': // håndtryk
			return <IconNy />;
		case 'icon-servicetjek-boern': // fugleunge
			return <IconBoern />;
		case 'icon-servicetjek-sygdom': // lægetaske
			return <IconSygdom />;
		case 'icon-servicetjek-pension': // sparegris
			return <IconPension />;
		case 'icon-servicetjek-pension-kalender': // kalender + ur
			return <IconKalender />;
		case 'icon-servicetjek-doed': // gravsten
			return <IconDoed />;
		case 'icon-servicetjek-kontakt': // callcenter headset
			return <IconKontakt />;
		case 'icon-servicetjek-uddannelse': // bøger + æble
			return <IconUddannelse />;
		case 'icon-servicetjek-fejl': // mandikon med spørgsmålstegn
			return <IconFejl />;
		case 'icon-servicetjek-opdateret': // mandikon med hjerte
			return <IconOpdateret />;
		case 'icon-servicetjek-saml': // pengesæk + mønter
			return <IconSaml />;
		case 'icon-servicetjek-arbejde': // mandikon med idkort
			return <IconArbejde />;
		case 'icon-servicetjek-jobskifte': // briefcase + pil
			return <IconJobskifte />;
		case 'icon-servicetjek-fritid': // cykel + træ
			return <IconFritid />;
		case 'icon-servicetjek-startpension': // sparegris + play ikon
			return <IconStartPension />;
		case 'icon-servicetjek-talesammen': // to mennesker + taleboble
			return <IconTaleSammen />;
		case 'icon-servicetjek-udbetaling': // hånd + mønter
			return <IconUdbetaling />;
		default:
			// bad practice temporary fix.
			return Url ? <img src={ Url } alt={ Type } className={ Type } /> : null;
		}
	};

	const renderIllustration = () => {
		if (Url?.includes('spar')) {
			return <Lottie animationData={ IllustrationSpar } loop={ true } className={ Type } />;
		}

		if (Url?.includes('doed')) {
			return <Lottie animationData={ IllustrationDoed } loop={ true } className={ Type } />;
		}

		if (Url?.includes('forsikring')) {
			return <Lottie animationData={ IllustrationForsikring } loop={ true } className={ Type } />;
		}

		if (Url?.includes('overgange')) {
			return <Lottie animationData={ IllustrationOvergange } loop={ true } className={ Type } />;
		}

		if (Url?.includes('pension')) {
			return <Lottie animationData={ IllustrationPension } loop={ true } className={ Type } />;
		}

		if (Url?.includes('samle')) {
			return <Lottie animationData={ IllustrationSamle } loop={ true } className={ Type } />;
		}

		if (Url?.includes('ordning')) {
			return <Lottie animationData={ IllustrationOrdning } loop={ true } className={ Type } />;
		}

		if (Url?.includes('livshaendelse')) {
			return <Lottie animationData={ IllustrationLivshaendelse } loop={ true } className={ Type } />;
		}
	};

	const renderImage = () => {
		return <img src={ Url ?? '' } alt={ Type } className={ Type } />;
	};
	const renderVideo = () => {
		return (
			<div
				className="video-content"
				id={ matomoVideoId }
				onClick={ () => {
					if (typeof handleClick === 'function') {
						handleClick({ modalGraphic: { Type, Url } });
					}
				} }>
				<img src={ Preview ?? '' } alt={ Type } className={ `${Type} preview` } />
				<IconPlay />
				<p>{ Title }</p>
			</div>
		);
	};

	return (
		<>
			{ Type?.toLowerCase() === 'icon' && renderIcon() }
			{ Type?.toLowerCase() === 'illustration' && renderIllustration() }
			{ Type?.toLowerCase() === 'image' && renderImage() }
			{ Type?.toLowerCase() === 'video' && renderVideo() }
		</>
	);
};

export default Graphics;